import { resolvePublicPath, runtimeConfig } from '@app/config/runtime'

export const getPublicAssetUrl = (assetPath: string) =>
  resolvePublicPath(assetPath)

export const sharedAssets = {
  audio: (fileName: string) => getPublicAssetUrl(`audios/${fileName}`),
  flag: (fileName: string) => getPublicAssetUrl(`flags/${fileName}`),
  image: (fileName: string) => getPublicAssetUrl(`images/${fileName}`),
  locale: (language: string, namespace: string) =>
    getPublicAssetUrl(`locales/${language}/${namespace}.json`),
  publicBasePath: runtimeConfig.publicBasePath,
} as const
